import script from "./WarrantyClaimItem.vue?vue&type=script&lang=js"
export * from "./WarrantyClaimItem.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__